/** @format */

import { Routes, Route, Navigate } from "react-router-dom";

import Login  from "../Pages/auth/Login";
import SignUp from "../Pages/auth/SignUp";
import ForgetPass from "../Pages/auth/ForgetPass";
import AuthRules from "../Pages/auth/Rules";

const AuthRouter = () => {
  return (
    <Routes>
      <Route path='*' element={<Navigate to={"/auth/login"} />} />
      <Route path='/auth/login' element={<Login />} />
      <Route path='/auth/signup' element={<SignUp />} />
      <Route path='/auth/forgot' element={<ForgetPass />} />
      <Route path='/auth/agreement' element={<AuthRules />} />
    </Routes>
  );
};

export default AuthRouter;
